(function () {
  function initCustomFretForm(root) {
    if (root.dataset.semiCustomInitialized === 'true') return;

    var productId = root.getAttribute('data-semi-custom-fret');

    var textInput = document.getElementById(
      'semi-custom-fret-text-' + productId
    );

    var fontSelect = document.getElementById(
      'semi-custom-fret-font-' + productId
    );

    var preview = document.getElementById(
      'semi-custom-fret-preview-' + productId
    );

    var selectedColorLabel = document.getElementById(
      'semi-custom-fret-selected-color-' + productId
    );

    var colorInputs = root.querySelectorAll(
      'input[name="properties[Color]"]'
    );

    if (!textInput || !fontSelect || !preview) return;

    var form = root.closest('form');

if (form) {
  form.removeAttribute('novalidate');
}

    function updatePreview() {
      preview.textContent = textInput.value || 'Your text';
      preview.dataset.font = fontSelect.value || '';
    }

    function updateSelectedColor() {
      if (!selectedColorLabel) return;

      var selectedColor = root.querySelector(
        'input[name="properties[Color]"]:checked'
      );

      selectedColorLabel.textContent = selectedColor
        ? 'Selected color: ' + selectedColor.value
        : 'Selected color: Not selected yet';
    }

    textInput.addEventListener('input', updatePreview);
    fontSelect.addEventListener('change', updatePreview);

    colorInputs.forEach(function (input) {
      input.addEventListener('change', updateSelectedColor);
    });

    updatePreview();
    updateSelectedColor();

    root.dataset.semiCustomInitialized = 'true';
  }

  function initAllCustomFretForms() {
    document
      .querySelectorAll('[data-semi-custom-fret]')
      .forEach(initCustomFretForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCustomFretForms);
  } else {
    initAllCustomFretForms();
  }

  document.addEventListener('shopify:section:load', initAllCustomFretForms);
})();

(function () {
  function initCustomRodForm(root) {
    if (root.dataset.semiCustomRodInitialized === 'true') return;

    var productId = root.getAttribute('data-semi-custom-rod');

    var form = root.closest('form');

    if (form) {
      form.removeAttribute('novalidate');
    }

    var layoutInputs = root.querySelectorAll(
      'input[name="properties[Text Layout]"]'
    );

    var line1Input = document.getElementById(
      'semi-custom-rod-line-1-' + productId
    );

    var line1Font = document.getElementById(
      'semi-custom-rod-font-line-1-' + productId
    );

    var line2Wrap = document.getElementById(
      'semi-custom-rod-line-2-wrap-' + productId
    );

    var line2Input = document.getElementById(
      'semi-custom-rod-line-2-' + productId
    );

    var line2Font = document.getElementById(
      'semi-custom-rod-font-line-2-' + productId
    );

    var previewLine1 = document.getElementById(
      'semi-custom-rod-preview-line-1-' + productId
    );

    var previewLine2 = document.getElementById(
      'semi-custom-rod-preview-line-2-' + productId
    );

    if (
      !layoutInputs.length ||
      !line1Input ||
      !line1Font ||
      !line2Wrap ||
      !line2Input ||
      !line2Font ||
      !previewLine1 ||
      !previewLine2
    ) {
      return;
    }

    function isTwoLines() {
      var selectedLayout = root.querySelector(
        'input[name="properties[Text Layout]"]:checked'
      );

      return selectedLayout && selectedLayout.value === 'Two lines';
    }

    function updateRodPreview() {
      var twoLines = isTwoLines();

      previewLine1.textContent = line1Input.value || 'Your text';
      previewLine1.dataset.font = line1Font.value || '';

      previewLine2.hidden = !twoLines;

      if (twoLines) {
        previewLine2.textContent = line2Input.value || 'Second line';
        previewLine2.dataset.font = line2Font.value || '';
      }
    }

    function updateRodLayout() {
      var twoLines = isTwoLines();

      line2Wrap.hidden = !twoLines;
      line2Input.disabled = !twoLines;
      line2Input.required = twoLines;
      line2Font.disabled = !twoLines;
      line2Font.required = twoLines;

      updateRodPreview();
    }

    layoutInputs.forEach(function (input) {
      input.addEventListener('change', updateRodLayout);
    });

    line1Input.addEventListener('input', updateRodPreview);
    line1Font.addEventListener('change', updateRodPreview);
    line2Input.addEventListener('input', updateRodPreview);
    line2Font.addEventListener('change', updateRodPreview);

    updateRodLayout();

    root.dataset.semiCustomRodInitialized = 'true';
  }

  function initAllCustomRodForms() {
    document
      .querySelectorAll('[data-semi-custom-rod]')
      .forEach(initCustomRodForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCustomRodForms);
  } else {
    initAllCustomRodForms();
  }

  document.addEventListener('shopify:section:load', initAllCustomRodForms);
})();